import { AulaState } from '@core/types/state';
import { SelectedUser } from '../types';

const changeConversationParticipants = (
  state: AulaState['inboxv2'],
  action: { type: string; payload: SelectedUser[] }
): AulaState['inboxv2'] => ({
  ...state,
  createConversationParticipants: action.payload,
});

export default changeConversationParticipants;
